// export default 'http://www.test.com/CqepcXG/WebAPI/'
//export default 'http://localhost/ScavcXG/WebApi/'
export default '/WebApi/'
//export default 'http://192.168.168.59/ScavcXG/WebApi/'



// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js